/* template */
<template><div :style="(subscriptStyle)" class="type-subscript-wrap"><div :style="(periodBg)" class="period-wrap" v-if="(cardData.period)">{{ cardData.period }}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3ef92790"}'>
.type-subscript-wrap
  width 492rpx
  height 100%
  position relative
  .period-wrap
    position absolute
    // right 219rpx
    left 188rpx
    top 20rpx
    padding 4rpx 13rpx 3rpx 13rpx
    background-image linear-gradient(150deg, #FFE9FF 0%, #EAF0FF 56%, #E8ECFF 100%)
    border-radius 75.9rpx 75.9rpx 75.9rpx 2rpx
    font-size 18rpx
    font-weight 600
    color #6254C7
    letter-spacing -0.21px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  properties: {
    cardData: {
      type: Object,
      value: () => {},
    },
  },
  computed: {
    // 卡面物料
    cardMaterial() {
      const apolloCardMaterial = this.cardData?.material || {}
      const misCardMaterial = this.cardData?.material_mis?.diyCardStyle || {}
      // mis配置物料
      if (this.cardData?.material_mis?.style === 1) {
        return {
          card_tag_bg: misCardMaterial.listCardTag,
          card_tips_bg_color: misCardMaterial.cardPhaseBubbleBackgroundColor,
          card_tips_text_color: misCardMaterial.cardPhaseBubbleTextColor,
        }
      }
      // apollo兜底物料
      return {
        card_tag_bg: apolloCardMaterial.card_tag_bg,
        card_tips_bg_color: apolloCardMaterial.card_tips_bg_color,
        card_tips_text_color: apolloCardMaterial.card_tips_text_color,
      }
    },
    subscriptStyle() {
      return `background-image: url(${this.cardMaterial.card_tag_bg});background-repeat: no-repeat;background-size: 100% 100%; color: ${this.cardMaterial.card_tips_text_color}`
    },
    periodBg() {
      return `background-image: ${this.cardMaterial.card_tips_bg_color}; color: ${this.cardMaterial.card_tips_text_color}`
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "type-subscript3ef92790",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
